import Masonry from "react-masonry-css";
import StaffDashboardOverviewCompact from "./StaffDashboardOverviewCompact";
import StaffDashboardOverview from "./StaffDashboardOverview";
import StaffDashboardRegistrations from "./StaffDashboardRegistrations";
import { useState } from "react";
import { Backdrop, CircularProgress, FormControlLabel, Switch } from "@mui/material";

export default function StaffDashboard({ setCurrent }) {
    const [loadingArray1, setLoadingArray1] = useState(1);
    const [loadingArray2, setLoadingArray2] = useState(1);
    const [loadingArray3, setLoadingArray3] = useState(1);

    const [showActive, setShowActive] = useState(true);   // State for "Show Active" toggle
    const [showInactive, setShowInactive] = useState(false); // State for "Show Inactive" toggle

    const breakpointColumnsObj = {
        default: 2,
        1600: 2,
        864: 1
    };

    return (
        <div style={{ width: '100%' }}>
            {/* Toggle controls */}
            <div style={{ display: 'flex-start', justifyContent: 'center', marginBottom: 20, marginLeft: 35 }}>
                <FormControlLabel
                    control={<Switch checked={showActive} onChange={() => setShowActive(!showActive)} />}
                    label="Show Active"
                />
                <FormControlLabel
                    control={<Switch checked={showInactive} onChange={() => setShowInactive(!showInactive)} />}
                    label="Show Inactive"
                />
            </div>

            {/* Loading backdrop */}
            <Backdrop open={(loadingArray1 === true || loadingArray2 === true || loadingArray3 === true)} style={{ zIndex: 1000 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* Dashboard Panels */}
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="easyhr-masonry-grid"
                columnClassName="easyhr-masonry-grid_column">
                <StaffDashboardRegistrations
                    setCurrent={setCurrent}
                    setLoadingArray={setLoadingArray1}
                    showActive={showActive}
                    showInactive={showInactive}
                />
                <StaffDashboardOverview
                    setCurrent={setCurrent}
                    setLoadingArray={setLoadingArray2}
                    showActive={showActive}
                    showInactive={showInactive}
                />
                <StaffDashboardOverviewCompact
                    setLoadingArray={setLoadingArray3}
                    showActive={showActive}
                    showInactive={showInactive}
                />
            </Masonry>
        </div>
    )
}
